import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    addCourseIntervention
 } from 'Actions';

class AddItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {

	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student:this.props.data.student, 
            seldate:'',        
            
        };
    }

    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });        
    }    

    addHandleSubmit(event){
        event.preventDefault();
        var studentid=this.state.student;
        this.props.addCourseIntervention(event, studentid).then((data) => {   
        
            if(data.status==1){ 
                document.getElementById("addform").reset();                   
            }

            setTimeout(() => {
                this.props.onClick();
            }, 2000);
        });
        
    }  


render() {

    const { loading} = this.props;  
    
      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-8" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="Create Course intervention">   
                                <div className="row float-right"> 
                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                                </div>  
                                    <div className="row">   
                                        <div className="col-sm-12 col-md-7">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    /> 
                                            </FormGroup>                                          
                                        </div>                               
                                        <div className="col-sm-12 col-md-7">   
                                            <FormGroup>
                                                <Label for="name">Coach Name *</Label>
                                                <input type="text" name="coachname" id="coachname" className="form-control form-control-alternative" required/>
                                            </FormGroup>  
                                        </div> 
                                        <div className="col-sm-12 col-md-10">
                                            <FormGroup>
                                                <Label for="Select">Observation</Label>
                                                <textarea rows="3" type="text" name="observation" id="observation" className="form-control form-control-alternative"></textarea>
                                            </FormGroup>
                                       </div>
                                       <div className="col-sm-12 col-md-10">
                                            <FormGroup>
                                                <Label for="Select">Work in Progress</Label>
                                                <textarea rows="3" type="text" name="workin" id="workin" className="form-control form-control-alternative"></textarea>
                                            </FormGroup>
                                       </div>
                                       <div className="col-md-12">
                                        <div className="form-group"> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />     
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused}) => {
    const { loading } = mostlyused;
    return {loading };
   
}


export default connect(mapStateToProps, { 
    addCourseIntervention,
})(AddItems);
